
<ng-container *ngTemplateOutlet="(showEoYUpsellTopBanner ? eoyUpsellTopBanner : (showEoQUpsellTopBanner ? eoqUpsellBanner : defaultTrialBanner))">
</ng-container>

<ng-template #eoyUpsellTopBanner>
  <div class="upgrade-top-bar success">
    <ng-container i18n>Get free hardware when you order by December 31st. &nbsp;</ng-container>
    <span class="upgrade-link" (click)="openLearnMoreCTA(learnMoreUrl)" i18n>Learn more</span>
    <div class="close" (click)="closeTopBar()"></div>
  </div>
</ng-template>

<ng-template #defaultTrialBanner>
  <div class="upgrade-top-bar" [class.danger]="trialRemainingDays <= 7">
    <ng-container i18n>Your Motive Pro trial will expire in {{trialRemainingDays}} days.&nbsp;</ng-container>
    <span class="upgrade-link" (click)="generalUpgradeModal.show($event)" i18n>Ready to Upgrade?</span>
    <div class="close" (click)="closeTopBar()"></div>
  </div>
</ng-template>

<ng-template #eoqUpsellBanner>
  <div class="upgrade-top-bar success">
    <ng-container i18n>Apply for the Motive Card By April 15th. Win $5,000. No hidden fees. &nbsp;</ng-container>
    <span class="upgrade-link" (click)="openLearnMoreCTA(learnMoreUrl)" i18n>Learn More</span>
    <div class="close" (click)="closeTopBar()"></div>
  </div>
</ng-template>


<general-upgrade-modal #generalUpgradeModal featureKeyName="general_upgrade" componentName="general-upgrade">
</general-upgrade-modal>

